<template>
  <div class="home">
    <Modal
      v-model="modal"
      width="360"
      :closable="false"
      :mask-closable="false"
    >
      <p
        slot="header"
        class="headerSelf"
      >
        <Icon
          type="ios-information-circle"
          size="18"
        ></Icon>
        <span>身份验证</span>
      </p>
      <div class="conSelf">
        <span class="leftSpan">姓名：</span>
        <input
          type="text"
          v-model="name"
          maxlength="10"
          :class="errorclass ? errorclass : ''"
          @focus="removeError"
        />
        <p
          v-if="false"
          :style="errorclass ? 'color:#f5222d;' : ''"
        >
           {{ errorCon }}
        </p>
      </div>
      <div class="conSelf">
        <span class="leftSpan">身份证号：</span>
        <input
          type="text"
          v-model="nationalID"
          maxlength="18"
          :class="errorclass ? errorclass : ''"
          @focus="removeError"
        />
        <p
          v-if="errorclass"
          :style="errorclass ? 'color:#f5222d;' : ''"
        >
          {{ errorCon }}
        </p>
      </div>
      <div
        slot="footer"
        class="footerSelf"
      >
        <a
          @click="deal"
          v-if="type == 'join'"
        >验证</a>
        <a
          @click="dealSign"
          v-if="type == 'sign'"
        >验证</a>
        <a
          @click="dealResign"
          v-if="type=='resign'"
        >验证</a>
      </div>
    </Modal>
    <Loading
      ref="loading"
      style="z-index:9999;"
    ></Loading>
  </div>
</template>
<script>
import Loading from "@/components/Loading";
import util from "@/utils/util";
export default {
  name: "Authentication",
  components: {
    Loading,
  },
  data() {
    return {
      modal: true,
      type: this.$route.params.type, //入职材料join，劳动合同sign  续期resign
      nationalID: "", //身份证信息
      name: "", //姓名
      errorclass: "",
      errorConName:"请输入正确的姓名",
      errorCon: "请输入正确的身份证号",
    };
  },
  computed: {},
  created() {
    console.log(this.type);
  },
  methods: {
    //验证
    deal() {

      //add by zhanglei 2021-11-03 start
      var randomId=Date.parse(new Date());
      if(this.$matomo) this.$matomo.trackEvent("EHR008#1#"+randomId,"start#LOGIN","登录");
      //add by zhanglei 2021-11-03 end

      let that = this,
        rule = /^\d{6}\d{4}\d{4}(\d{1}|(\d{3}[0-9xX]))$/g;
      //校验失败
      if (!rule.test(that.nationalID)||!this.name) {
        that.errorclass = "error";
      } else {

        //设置piwik的系统信息
        util.setPiwikInfo({
          name:'非销售电子续签-员工端',
          code:'EHR008'
        });

        that.errorclass = "";
        //调后台验证是否正确
        that.$refs.loading.show();
        that.axios
          .post("/join/eprotocol/employee/verify", {
            nationalID: that.nationalID,
          })
          .then((res) => {
            let data = res.data;
            that.$refs.loading.hide();

            //add by zhanglei 2021-11-03 start
            if(this.$matomo) this.$matomo.trackEvent("EHR008#1#"+randomId,"end#LOGIN","登录");
            //add by zhanglei 2021-11-03 end

            if (data.status == "success") {
              //设置piwik
              localStorage.setItem("piwikCode",res.data.result);
              if(that.$matomo) that.$matomo.setUserId(res.data.result);
              //add by zhanglei 2020-10-28 start
              if(that.$matomo) that.$matomo.trackEvent("EHR008#1","LOAD","登录页");
              //add by zhanglei 2020-10-28 end
              //跳转到入职材料或者签署合同
              that.$router.push({
                path: "/tojoinIn/joinHome",
              });
            } else {
              that.errorCon = data.message;
              that.errorclass = "error";
            }
          })
          .catch((error) => {
            that.$refs.loading.hide();
            that.$Message.error({
              title: "信息",
              content: error,
            });
          });
      }
    },
    //合同签署
    dealSign() {
      let that = this;
      that.$refs.loading.show();
      that.axios
        .post("/sign/eprotocol/agreement/getUserInfo", {
          idNo: that.nationalID,
          name: that.name,
        })
        .then((res) => {
          let data = res.data;
          that.$refs.loading.hide();
          if (data.code == "OK") {
            //存登录人基本信息
            that.$store.commit("saveSignInfo", {
              signInfo: res.data.result,
            });            
            //设置piwik
            localStorage.setItem("piwikCode",res.data.result.id);
            if(that.$matomo) that.$matomo.setUserId(res.data.result.id);
            //合同材料需要字段
            localStorage.setItem("contractPid", res.data.result.id);
            localStorage.setItem("contractIdNo", res.data.result.employeeId);
            //是否是实习生
            that.$store.commit('savePersonType',res.data.result.isTrainee=='true'?true:false);
            //查流程
            that.initData(res.data.result);
          } else {
            that.errorCon = data.message;
            that.errorclass = "error";
          }
        })
        .catch((error) => {
          that.$refs.loading.hide();
          that.$Message.error({
            title: "信息",
            content: error,
          });
        });
    },
    //合同续签
    dealResign() {
      let that = this;
      that.$refs.loading.show();
      that.axios
        .post("/sign/archives/sign/verifyPerson", {
          idNo: that.nationalID,
          name: that.name,
        })
        .then((res) => {
          let data = res.data;
          that.$refs.loading.hide();
          if (data.code == "OK") {
          	that.$router.push({
              path: "/toResign/resignHome",
            });
            /*that.$router.push({
              path: "/toResign/codeIdentify",
            });*/            
            //设置piwik
            localStorage.setItem("piwikCode",res.data.result.employeeId);
            //存登录人基本信息
            that.$store.commit("saveSignInfo", {
              signInfo: res.data.result,
            });
            //存公司名称
            that.$store.commit("setCompany", {
              companyInfo: res.data.result.checkName,
            });
          } else {
            that.errorCon = data.message;
            that.errorclass = "error";
          }
        })
        .catch((error) => {
          that.$refs.loading.hide();
          that.$Message.error({
            title: "信息",
            content: error,
          });
        });
    },
    initData(data) {
      let that = this;
      that.$refs.loading.show();
      this.axios
        .post("/join/eprotocol/reminder/query_reminder_detail", {
          proType: "1",
          pid: data.id + "",
        })
        .then((res) => {
          that.$refs.loading.hide();
          let data = res.data;
          if (data.status == "success") {
            that.$router.push({
              path: "/tosign/codeIdentify",
            });
          } else {
            that.$Message.error({
              title: "信息",
              content: data.message,
            });
          }
        })
        .catch((error) => {
          that.$refs.loading.hide();
          //console.log(error);
          that.$Message.error({
            title: "信息",
            content: error,
          });
        });
    },
    removeError() {
      this.errorclass = "";
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.headerSelf {
  color: #f60;
  text-align: center;
  .ivu-icon {
    margin-right: 10px;
  }
}
.ivu-modal-body .conSelf {
  text-align: center;
  margin: 20px auto;
  input {
    line-height: 32px;
    height: 32px;
    border: 1px solid #dcdee2;
    border-radius: 5px;
    outline: none;
    padding-left: 10px;
    width: 70%;
    &.error {
      border: 1px solid #f5222d;
    }
  }
  p {
    line-height: 32px;
    position: absolute;
    text-align: center;
    width: 100%;
  }
}
.ivu-modal-footer .footerSelf {
  text-align: center;
  a {
    width: 100%;
    display: block;
    text-align: center;
    background: #1890ff;
    color: #fff;
    line-height: 32px;
    height: 32px;
    font-size: 16px;
    border-radius: 5px;
    border: 1px solid #1890ff;
  }
}
.leftSpan {
  width: 22vw;
  display: inline-block;
  text-align: right;
}
</style>
